import { mockCase } from "./mock.case-details"
import { mockCases, mockExport, mockFaq, mockKpi, mockState } from "./mock.data"

// Params are the ones the real endpoints are expected to take, so swapping in
// `request.api.get(...)` touches nothing above this layer.
export const getCompellingEvidenceState = ({ business_account_id: _businessAccountId }) =>
  mockState()

export const getCompellingEvidenceKpi = ({ business_account_id: _businessAccountId, program }) =>
  mockKpi({ program })

// Same filter params as Receipt's lookups (`toLookupFilterParams`), plus `outcome`.
export const getCompellingEvidenceCases = ({
  business_account_id: _businessAccountId,
  ...params
}) => mockCases(params)

// Everything the case drawer shows, fetched when it opens so the list stays light.
export const getCompellingEvidenceCase = ({ id, business_account_id: _businessAccountId }) =>
  mockCase({ id })

// Takes the list's params, so the file is the rows on screen. Answers with an acknowledgement;
// the CSV arrives by email, as on Receipt.
export const getCompellingEvidenceExport = (_params) => mockExport()

export const getCompellingEvidenceFaq = () => mockFaq()
